import { ReportsEffects } from 'app/store/reports/reports.effects';

export const AppEffects = [
	ReportsEffects
];
